import colors from "./colors";
const buttons = {
  primary: {
    fontSize: 2,
    fontWeight: "normal",
    color: "white",
    bg: "primary",
    background: colors.gradiantPrimary,
    borderRadius: "default",
    cursor: "pointer",
    transition: "all 300ms ease",
    minWidth: "175px",
    px: 5,
    py: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    "&:hover": {
      transform: "scale(1.05)"
    },
    i: {
      fontSize: 7,
      position: "absolute",
      top: "50%",
      right: "0",
      mr: 1,
      transform: "translateY(-50%)",
      "&:before": {
        margin: 0
      }
    }
  },
  categorieToggle: {
    variant: "buttons.primary",
    bg: "background",
    color: "primary",
    border: "1px solid",
    px: 6,
    borderColor: "gray30",
    "&:hover": { color: "primaryLight" }
  },
  golden: {
    variant: "buttons.primary",
    bg: "golden",
    "&:hover": { bg: "goldLight" }
  },
  store: {
    variant: "buttons.primary",
    bg: "black",
    py: 1,
    "&:hover": { bg: "#444444" }
  },
  outline: {
    variant: "buttons.primary",
    color: "primary",
    bg: "transparent",
    borderColor: "primary",
    border: "1px solid",
    "&:hover": { bg: "transparent" }
  },
  secondary: {
    variant: "buttons.primary",
    color: "text",
    bg: "secondary"
  },
  transparent: {
    variant: "buttons.primary",
    transition: "all 300ms ease",
    color: "inherit",
    bg: "transparent",
    "&:hover": { bg: "transparent" }
  },
  white: {
    variant: "buttons.primary",
    color: "primary",
    bg: "white",
    background: "white",
    justifyContent: "space-between"
  },
  ninja: {
    cursor: "pointer",
    color: "inherit",
    bg: "transparent",
    m: 0,
    p: 0,
    border: "none",
    transition: "all 300ms ease",
    "&:hover": {
      bg: "transparent",
      opacity: 1
    }
  },
  linkText: {
    variant: "buttons.ninja",
    color: "primary",
    fontSize: 8
  },
  mainMenuButton: {
    variant: "buttons.ninja",
    fontSize: 2,
    fontWeight: "bold",
    "&:hover": {
      color: "secondary"
    }
  }
};

export default buttons;
